var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNzlLotto6From40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m91.99 56.84-1.9-.67 1.49-1.25zm-16.4-2.86-1.68-4.44-3.29 3.87z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.81 50.31-2.9-.57 1.08 2.71z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.35 53.51-1.8-4.75-4.03 4z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.6 63.26-1.8-4.86 5.32.86z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.44 54.92-5.42-.94 1.96 4.92z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.15 62.53-5.02-.58 3.02-3.55zm-3.56 3.06-3.32 3.88-2.03-4.62z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.4 67.6 4.41-5.46-7.08-.81z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.81 57.23-1.38-4.07-3.16 3.75z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16 53.51 71 53.24l1.27 3.67z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.76 57.23 4.7.23L71 53.24z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.56 62.61-2.4-6.52 7.05 1.06z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.97 64.16 9.53 1.28-1.17-2.65-2.46-6.34z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.95 59.57 3.97.23-2.51 3.29z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.73 57.75-4.28 5.34-2.65-6.58z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#95d9f3"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.33 59.26 2.53 6.53-6.74-1.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m63.73 67.28 2.18-2.61-3.32-.33z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m67.14 68.73-1.4-3.85-2.98 3.54z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.49 63.09-.35-.95-.73.95z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.42 63.8-.51-1.08-.87 1.08zm4.07 6.14-1.75-5.06 5.42.81z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.96 65.53-.22-.65.72.1z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.04 54.92.69-.94.49 1.06z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.13 55.35-8.4-1.37 5.24-6.37z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.52 57.66-1.21-3.15-1.94 2.71z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81 54.32 1.18 3.43 2.07-2.9z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.61 59.8v-2.92l2.41-.37z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.41 66.86-1.87-4.74-3.32 3.9z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.23 58.16-3.42 3.98 5.46.95z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.02 65.4-.48-1.91 1.98.31z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.02 59.8-.8.82-.4-.82z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81 62.9.92-.85-1.29-.24z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81 64.99-.96-2.09-1.4 1.83z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.91 65.59-.28-1.1-.71.91z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.11 70.49-.25-2.62 2.36 1.24z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.6 71.21-.44-.87-.62.87zm2.31 2.92 1.53-1.37 1.44 1.04z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.42 69 3.39-.62.32 2.11z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.59 70.34 1.94-1.16-1.94-1.03z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.58 71.21 1.51.46-.34 1.09z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.13 66.42-.86-.83 1.06-.19z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.73 65.59.54-.93.71.93z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.61 51.48-2.37-6.35-4.54 5.2z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.17 53.51-1.15-2.83 3.14.45z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58 53.51v-1.68l-1.31.84z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.71 55.23-.58-1.99 2.07.42z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.12 57.23-2.23-.39.74 2.06z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.12 62.9-2.68-2.28 3.96.71z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.3 56.68-3.1-2.7 3.41.53z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.49 68.77-2.7 3.44-2.03-4.03z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.39 76.28-1.84-4.75 5.24.68zm-5.56-4.75 3.2.18-1.1-2.77z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.55 73.31-2.23-5.87 6.11 1.03z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.34 71.75-5.81-.85 3.81-4.68z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.94 67.79-2.8 3.42-1.49-4.15z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.19 74.8-1.66-3.9 4.32.63z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.01 69.71.76 2.04-2.17-.28z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.48 75.19-1.37-1.65 1.01-1.13z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.85 71.53.27.88.55-.76z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.74 74.41 2.43-1.56-1.45-.44z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.61 75.19 5.08.78-3.36 3.84z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.98 76.6-.45 2.15 2.16-.74zm2.79-1.26-.88-.54-.2.94z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.02 77.3-1.56 1.45 1.88.59z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.18 80.43-1.72-.23v1.02z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.32 82.47-.66-1.1-.75.82z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.92 83.68v-1.21l.88.6z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.34 83.25-.86-1.88-1.37 1.72z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.26 77.5 1.65-.2v.86z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.65 77.3.77-3.99 1.19 3.29zm3.29-2.89-1.18-.28.79-.82z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.35 76.83 1.02 2.98 2.39-2.51z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.38 73.04-2.35-.19 1.49-1.95z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.76 74.8-3.36-.39 1.25 3.09z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.99 76.99-.79-1.96 1.26-.62z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.97 73.17-.83-1.96 2.07.54z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.28 74.55 1.56-1.14.35 2.29z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.91 41.61 1.96-2.5-3.07-.49z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3 42.15 82 38.8l-2.09 2.81z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78 44.26 86 39.34l-3.33 3.95zm2.31-8.91-3.45 4.16-1.71-4.96z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.37 40.95-6.93-1.06 4.35-5.71z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.7 31.71-1.95-5.05-3.45 4.13z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.81 30.18-3.6 4.34 5.75.83z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.33 39.34-2.28-5.83-3.95 4.84z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.5 33.47-.43-1.06-.71.91zm-1.99 1.24 1.03 2.66 1.7-2.27zm5.04-6.33-.82-1.95 2.19.23z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.89 29.79-.66-2.11 1.33-.74z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.1 29.79.39 1.92 1.37-1.29z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.52 33.47 1.14-.27-.24 1.21z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.52 37.37 4.03-1.33-.31 1.93z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.77 43.8-.67-1.95 2.08.31z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.75 47.95.51-2.86-1.37.83z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.65 50.85-.39-1.02 1.02.31z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.31 39.46 2.61-3.05 1.37 3.71z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.46 33.8.68 1.69.96-.45z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92 39.07v1.2l-1.04-.6z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.54 40.45-.88-1.97-1.37 1.64z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.49 42.47 82 47.2l-2.09-5.59z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.61 42.5-1.02-.35.68-.76z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.73 48.52-5.29-.71 3.47-4.13z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.46 46.41-1.02 1.33-.58-1.52z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2 45.82h-2.15l.88-1.76z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.1 45.94.6-.85.37 1.01z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.11 46.98-1.38 1.54 2.05.53z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.4 50.51 3.26-1.37-.79 1.84z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.82 52.45.96-.65-.9-.52z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.09 50.46 1.77-2.06-2.52-.34z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.31 50.72-.76-1.96-1.46 1.7zm-18.44 5.89-1.44-3.99-2.96 3.63z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.39 58.93 2.02-2.37-3.01-.22z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.12 60.85-6.52-1.08 4.16-5.11z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.92 69.04-1.85-4.93.6-.74 5.33.83z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.29 67.54 6.95 1.05-2.48-6.41z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.77 66.92 3.6.66-1.3-3.47z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.59 64.34-5.92-.97 3.83-4.7z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.33 47.83 2.23 5.72-6.17-.88z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.32 57.8 3.53-4.36-5.46-.77z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82 47.2-10.72-1.75 6.9-8.47z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.02 50.68-6.65-1.1 3.22-4.13 1.53.23z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.69 48.73-3.41 4.09-1.95-4.99z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.59 45.45-2.25 2.88-1.48-3.61z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.86 52.12H71l.28.7z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#2a9cdb"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m74.18 41.89-2.32 2.83 3.73.73zm-.76 6.63-1.56-3.8-2.53 3.11z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m79.62 42.71-3.43 4.16-2.01-4.98z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.42 46.45.8 2.14 1.53-1.76z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.65 60.6-2.37 2.93-1.29-3.54z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.52 69.18-.32-1.9-1.44 1.14z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.33 59.8-.16-1.13.81.23z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.79 1.66.38 1.97-1.83-.65zm5.76 15.6-2.99 3.68 5 .89z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.78 18.04.95 2.8 1.81-2.29z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.75 8.19-3.2 3.95 5.48 1.47z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.06 6.55-3.3 3.99-1.92-5.03z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.93 9.14 1.91 5.16 3.26-4.17z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.15 9.89 2.02 4.63-4.58-.82zm4.44 1.54 5.02.92-2.97 4.08z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.42 14.04-6.92-1.06 2.85 6.51z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.75 14.57-2.82 3.25 4.82.84z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.36 17.87 1.86 3.73 2.53-2.94z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.29 22.39-2.16-4.17-2.91 3.38z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.04 14.68-4.44 5.35-2.62-6.63z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.69 24.78-3.68-8.88-1.7 2.34-4.25 5.31z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.73 23.65-1.79-3.55 4.1.52z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.75 16.97 6.76 1.02-4.36 5.59z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#95d9f3"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m44.26 20.02 4.38-5.47 2.5 6.33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m54 20.83-3.35-.57 1.38 3.03z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m53.54 17.16-2.62 3.15 4.55.79z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.5 19.68-.65.79 1.19.15z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.15 22.84-.68.99 1.37.21zm3.27-6.59-3.5 4.06-2.02-5.1z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.37 19.78-.45.53-.27-.68z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.65 18.99-1.16-.12.67-.96z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.46 10.92 3.03 7.95-8.13-1.33z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.26 11.15-2.11 2.63 3.32.32z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.74 16.9 2.38-2.74-3.55-.34z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.08 13.46-2.52 1.46-1.54-1.89z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.27 6.63-3.16 4 5.04.9z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.34 12.02 5.16.96-1.92-5.2z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.71 8.56-1.42 1.38-.72-1.87z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.87 11.38 1.11.27-.52.76z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.16 12.59-1.2-.36.44 1.24z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.96 11.55-1.32 1.87 2.28.3z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.43 12.88-.81.8 1.15.16z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.57 11.98-2.14 1.53-.11-2.66z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.45 12.06-.54.82 1.07.09zm1.36-3.46-1.95-.63.17-1.77z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.12 7.27-2.24-2.62 1.66-1.33z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.69 7.32-1.98-1.09.08 2.19z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.44 3.44-.36-1.53 1.11-.27z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.03 5.37-.29 1.16-.69-.83z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 2.67h-1.08l.46-1.08z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.37 11.58-4.3 5.24 6.78 1.31z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.85 13.54-1.86 2.41-1.19-2.94z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.14 12.32-1.45.84 1.38.71z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.07 10.47-1.43 1.51-.68-2z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.08 6.53.78 2.13 1.41-1.68z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.98 3.69-.62 3.45-1.38-3.78z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.01 5.78-.78 4.04-1.25-3.21z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.4 16.83 4.33.61-2.46 3.78z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.96 18.34-3.19 3.98-2.04-4.88zm-1.32 7.19-1.45-2.87-1.85 2.35z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.31 21.42-3.95 4.87-2.18-5.8z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.57 24.98 2.19 5.44-5.96-.95z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.85 24.72 4.35.69-2.83 3.38z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.29 27.03-2.53 3.39-1.63-4.05z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.48 28.87 1.38-1.67.85 2.01z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.98 23.99 64.24 26l-1.49-.31z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.13 26.37.62-.68-.93-.09z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.68 30.2-2.57-1.31.35 1.47z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.92 30.79-1.87-4.78 5 .97z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.45 27.18 2.09-.7-1.73-1.49zm-2.48-1.79-.04 1.03.92-.29z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.04 30.24 2.04.62-.43-1.91z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.67 30.26.66 1.6.88-.51z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.86 29.98-.61 1.12 1.08.23z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.6 25.4-1.05.6.09-1.06z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.51 19.2-1.19 1.69 2.17.32z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.58 23.88-.99-1.32.74-.43z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.21 21.92-3.83 1.34 2.24-2.68zm-4.15-1.39.35 1.15-1.1-.26z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.45 19.82 2.06-2.37-3.36-.81z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.15 16.52 1.01 2.12-2.43-.3z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.47 13.57 1.35 3.11 2.04-2.64z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.76 14.87-1.3 1.66-1.17-.77z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.96 14.21-1.27 1.71-.58-2.07z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 13.25-1.77-.77 1.8-1.46z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7 19.73-3.14-.44 1.12 2.9z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.47 16.53-2.24 2.81 3.47.39z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.04 11.6-3.36 4.01 5.09.89zm-8.86 2.48 5.33.9-3.43 3.96z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.38 13.62 2.57 6.52-7.12-.89z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.74 17.11-3.39 4.22 5.3.9z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.87 22.1 5.55.93-2.17-5.38z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.02 17.92-3.89 4.89 6.16.99z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.87 20.72-.7.9 1.13.16zm2.07 1.09 1.78-2.22-2.82-.34zm-8-1.18-1.28 1.7-.89-2.02z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.98 16.17-1.49 1.64-1.31-.78z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.37 13.4 1.46-1.3-1.8-.54z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.84 15.51-.8-.84 1.16-.41z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.21 13.56-3.17-2.82 1.83-.7z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.14 5.8-1.36 1.55-.77-1.95z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.24 6.32-2.73.99 1.4.77z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.29 4.09-.69.85-.24-1.04z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.13 16.15-3.94-.73 2.52-3.05z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.67 17.99 1.11-1.43-.87-.61z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.49 14.09 1.03-.6v1.19z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.86 10.27-1.26 1.75 2.11.35z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.64 14.48 5.84.64-3.78 4.61z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.62 17.82.2 1.05-.99-.2z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.75 11.24 2.04 4.92-5.31-.92z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.56 11.67 1.67.21-1.03 1.26z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.18 12.19 1.08 1.85-1.96.13z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.33 10.48-1.03-.09.68-.83z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.73 10.82 2.02.42-.57-2.04z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.64 8.79-2.83-2.12 1.99-.24z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 8.32-1.04-.51-.01 1.05z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.75 12.55-2.67-.51.98 2.36z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.86 10.5-1.31 1.64 2.2.41zM43.2 23.47l-2.72 3.25 4.62.74z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.95 23.58-3.06-.55 1.32 2.71z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.24 21.99 2.34 6.18-6.5-1.04z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.44 24.97-3.33 4.08-.95-.15-1.96-5.03z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.46 26.27-2.58-6.54-4.29 5.37z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.69 29.62-1.24-3.44-2.34 2.87z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.03 23.29 2.13 5.61-5.97-.95z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.39 25.75 3.82-4.79 2.33 5.77z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.01 22.48-5.53-.85 2.06 5.1z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.48 15.12 3.87 10.15-10.79-1.72z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.99 15.95 2.38 6.3-5.19-.71-.56-1.44z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.47 20.67 5.25.9-3.33 4.18z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.18 21.54 3.62.5-2.37 3.08z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.82 21.41.43.75.47-.59z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#2a9cdb"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m26.82 24.55 3.61.57-1.25-3.58zm6.11-2.68-2.5 3.25 3.96.63z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m24.79 19.43 5.33.88-3.3 4.24z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.13 19.46 1.45-1.77-2.29-.44z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.77 23.38 3.72.59-2.41 2.89z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.25 19.2-1.48 1.22 1.7.68z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.2 10.24-.89.71-.21-.82z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.59 81.84 1.53-1.31.34 1.91zm10.68-12.77 4.68.77-1.71-4.79z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.83 71.96 1.95-2.22-2.89-.43z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.29 78.63 5.02.81-1.46-5.49z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.73 70.49 5.11.88-3.41 4.17z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.03 76.26 3.52-4.22-5.24-.76z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.08 67.88 3.02-4.06 1.56 4.39zm-.87-4.62-1.7-4.82 5.02.56z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.57 58.63 2.53 6.55 4.23-5.73z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.84 68.5 4.22.84-1.67-4.61z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.89 68.93 2.31-3.47-3.81-.73z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.36 60.67-2.54 3.95 4.38.84z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.81 62.99 6.84 1.19-4.44 5.58z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.77 51.32-5.88 7.61 2.88.31 6.72 1.05z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.75 57.06-2.19 3.32-1.59-3.82z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.93 65.57-2.49-6.37 7.03 1z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#95d9f3"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22.83 61.01-6.93-1.07 4.25-5.34z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.68 52.15 1.17 3.19 1.95-2.71z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m15.72 54.38 4.04.71-1.58-4.36z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.43 57.5 1 .17-.46-1.11z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.85 53.62 1.19.1-.5-1.29zm-7.35.45 5.26 1.02-3.42 4.29z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.08 54.96.68.13-.45.57z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.73 66.39.47 1.07-1.17-.1z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.81 74.04 5.39-6.58 2.89 7.72z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.62 71.5 3.33.53-1.38-3.05z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.87 69.09-3.57-.7 1.48 3.25z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.72 67.04 2.52 1.46-.88 2.27z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.71 66.8 5.04.75-1.73-4.82z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.83 70.13-1.73-4.95-3.56 4.25z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.66 66.32 1.9.55-1.26 1.56z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.51 69.12-.31-1.1.91.07z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.43 64.8.28 1.22.86-1z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.62 63.75 2.29.22-.88-2.13z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.05 61.81 1.1.31-.44-1.08z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.71 57.79 2.39 1.11-2.25 1.42z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.34 57 .98.05-.45-.97zm-3.68.53.42 2.01-1.62.74z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.84 64-1.16 3.26-1.98-.79z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.1 62.62.03 2.26L11 63.71z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35 65.64 5.2 66.71l-.78-.83z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.22 68.51 1.15-.33-.37 1.01z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.14 72.04.53.94-1.16.14z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.42 77.27 6.69 1.12-2.24-6.54z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.38 73.27 3.03.42-1.97 2.5z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.68 74.49 1.45.84-.07-1.55z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.62 74.61 2.02.49-1.41 1.58z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.19 76.56 1.45-1.73-2.15-.39z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.28 73.73 3.31-1.19-2.6 3.08z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.07 77.86 3.89-1.34-2.16 2.69z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.51 54.66-1.63-4.06 4.51.25z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.06 45.61 5.04.79-3.22 4.2zm6.9-2.43-1.77 2.68 2.96.44z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.55 45.51 6.2 1-3.95 4.78z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.51 43.51 3.64-4.61 2.15 5.65z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.64 47.75-1.57-4.14 4.35.78z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.95 38.39 4.2.51-2.71 3.43z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.94 41.65-2.14-.36 1.32-1.74z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.96 41.05 2.11-.37.48 1.45z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.44 42.33-.89-.2.38.85z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.01 35.61.13 2.88 1.11-1.04z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.9 34.23-3.22 4.01-1.64-4.83z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.99 36.44-1.63-1.46-.44 2.24zm-.31 3.05.91-.49-.71-.64z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.36 32.67-.47-2.08-1.45 1.33z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.57 29.51 1.07-1.37-.89-.51z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.24 27.75 1.28-.03-.34-1.06z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.89 31.12 1.05.61-.97.46z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.55 37.76 2.06.19-.81-2.05z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.57 38.84-.65 1.52-.75-.43z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.55 41.01 3.07 2.66-3.44-.62zm.86 4.29.82-.88.32 1.09z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.6 43.58-3.08-.6.97 3.31z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.87 50.69 1.34-1.93.94 2.26z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.16 51.88 2.02-2.72-3.3-.46z",
    style: {
      fill: "#fff9c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.65 48.38 2.08.3-.08 1.4z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.46 52.88 2.11.25-1.49 1.53z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.11 52.45.21 1.92-2.16-.84z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.81 79 34 81.94l1.96-2.41z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.65 81.66 3.55.55L32.81 79z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.58 84.49 5.15.92-1.75-4.86zm6.57 6.46-1.88-5.07 5.15 1z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.66 85.79 4.38-5.47 2.77 6.62z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.99 91.56 5.35.83-1.85-5.04z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.76 88.09-1.96-5.28-3.59 4.56z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.07 83.09 6.19.95-2.21-5.85z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.07 86.18 1.13.16-.43-1.07zm-.08-2.34-2.82-.44 1.11 2.6zm2.96 7.52 2.1.27-1.3 1.78z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.56 94.42 2.16.48-.02 1.52z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.95 97.2-1.86-.62.44 1.83z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.06 91.39-.34 1.12-.93-.81z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.68 89.44-.87 4.16-1.51-1.24z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.49 90.77 2.02.4-1.31 1.64z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 86.08 2.22 1.87-.03-1.59z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.44 85.41 1.08.17-.78.73z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.98 84.75 1.34 3.79-3.91-.68z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.3 88.58-1.8-.26-.09 1.06z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.01 87.21-1.04-.61 1.04-.59z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.01 89.65 2.14.22-.74-2.01z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.28 83.4-2.35-5.39 5.88.99z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.2 80.02.81-.7.32.97z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.93 80.58 3.25-4.22 1.85 5.07z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.39 82.27-.65-1.55 1.61.26z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.03 82.34 1.07-1.86 1.09 1.64z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.97 83.93.43.94-1.05-.18z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.56 82.54-.63-1.96-1.49 1.52z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.36 81.03-.44 3.51-1.2-1.61z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.97 79.56.08 1.15.91-.51z",
    style: {
      fill: "#262658"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.57 77.32.89 2.57 1.55-2.02z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.23 79.12 2.08.32-.74-2.12zm4.12-18.91 4.18.74-1.67-4.38z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.08 57.76 1.04 2.94 1.7-2.5z",
    style: {
      fill: "#ad91c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.06 57.44 4.19-5.11 2.34 6.16z",
    style: {
      fill: "#5553a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.07 46.23 5.19.87.34.89-3.39 4.2z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.68 46.44-4.39 5.49 6.79 1.06z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.97 43.7-2.37 2.79 3.66.61z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.8 52.63 3.8-4.64 2.15 5.66z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.72 66.72-6.06-.92 3.85-4.9z",
    style: {
      fill: "#2a9cdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.09 60 2.01 5.23 3.41-4.33z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.93 78.01 6.88-8.41 3.88 10.22z",
    style: {
      fill: "#1a69aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.41 73.69 4.28-5.2 1.97 4.85-.97 1.2z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.26 70.92-1.83-5.01 5.29.81z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.66 73.34-1.38-3.39 3.86.53z",
    style: {
      fill: "#fcda35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.74 66.78.43-.75-.74-.12z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#2a9cdb"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m35.44 73.9-1.3-3.42-2.48 2.86zm-5.36-3.98 4.06.56-1.42-3.76z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m32.01 78.2-1.89-5.06 5.32.76z",
    style: {
      fill: "#25256d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.87 74.42-2.25-.37.76 2.2z",
    style: {
      fill: "#65cbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 56.29-1.34-3.52 3.7.65z",
    style: {
      fill: "#95d9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.64 51.88 1.8.68-.26-1.83z",
    style: {
      fill: "#9c3692"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.86 70.27 1.05.42-.6.59z",
    style: {
      fill: "#65cbf3"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m39.29 84.68 41.98-51.49-65.5-10.42z",
    fill: "#019ee1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.72 41.31-1.42.24-.44-2.63-2.9.49.44 2.62-1.39.23.4 2.4 1.39-.23.95 5.71 2.9-.48-.96-5.72 1.28-.21zm5.93-.99-1.41.24-.44-2.63-2.89.49.43 2.62-.15.03-1.07 2.63 1.62-.27.96 5.72 2.89-.48-.95-5.72 1.41-.23zm-23.3 9.56-1.54-9.19-2.85.48 1.96 11.77 6.68-1.11-.43-2.59zm7.3-7.15c-2.39.4-4.01 2.63-3.61 4.98.39 2.35 2.65 3.93 5.03 3.54 2.39-.4 4.01-2.63 3.61-4.98-.39-2.35-2.65-3.94-5.03-3.54zm1 6c-.98.16-1.9-.49-2.06-1.45s.5-1.87 1.48-2.04c.98-.16 1.9.49 2.06 1.45.16.97-.51 1.88-1.48 2.04zm19.18-9.36c-2.39.4-4.01 2.63-3.61 4.98.39 2.35 2.65 3.93 5.03 3.54 2.39-.4 4.01-2.63 3.61-4.98-.38-2.36-2.64-3.94-5.03-3.54zm1 6c-.98.16-1.9-.49-2.06-1.45s.5-1.88 1.48-2.04 1.9.48 2.06 1.45c.17.96-.5 1.87-1.48 2.04zm-27.3 11.61-.55.01-1.76-1.57.15 1.92-.72-.02-.41-3.07.53.01 1.79 1.47-.23-1.84.83-.04.37 3.13zm2.3-1.27-1.4.17c.04.32.19.46.47.43.14-.02.24-.1.29-.24l.65-.08c-.03.2-.09.35-.17.47-.16.21-.39.34-.7.37-.39.05-.69-.05-.92-.29-.17-.18-.27-.41-.31-.69-.04-.34.02-.62.17-.85.16-.23.4-.37.74-.41.41-.05.72.08.94.39a1.44 1.44 0 0 1 .23.64l.01.09zm-.68-.35c-.08-.23-.22-.34-.42-.31-.11.01-.2.06-.26.15a.42.42 0 0 0-.07.26l.75-.1zM47 54.09l-1.4.17c.04.32.2.46.47.43.14-.02.24-.1.3-.24l.65-.08c-.03.2-.09.35-.17.47a.95.95 0 0 1-.69.37c-.39.05-.7-.05-.92-.29-.17-.18-.27-.41-.31-.69-.04-.34.02-.62.17-.85.16-.23.4-.37.74-.41.41-.05.72.08.94.39a1.44 1.44 0 0 1 .23.64l-.01.09zm-.67-.35c-.08-.23-.22-.34-.42-.31-.11.01-.2.06-.26.15a.42.42 0 0 0-.07.26l.75-.1zm-5.37.18-.53 2.24-.4.07-.61-1.08-.21 1.22-.4.07-1.21-1.95.66-.11.59 1.04.24-1.18.37-.06.61 1.07.23-1.21.66-.12zm3.5-1.65-.97 2.65 1.38-.23.12.71-2.55.38.87-2.63-1.28.23.02-.71 2.41-.4zm5.3 2.33-.57-.03-.25-.12c-.06.1-.12.17-.18.22-.11.09-.24.14-.4.16a.99.99 0 0 1-.7-.18c-.26-.19-.41-.46-.46-.81-.05-.36.03-.66.24-.91.17-.2.37-.31.61-.34.14-.02.28 0 .41.04a.79.79 0 0 1 .24.15l-.03-.21.71-.09.38 2.12zm-.9-.97a.494.494 0 0 0-.18-.32.46.46 0 0 0-.34-.1c-.14.02-.25.09-.32.21a.52.52 0 0 0-.07.32c.01.12.06.22.15.3.1.1.22.14.37.12.13-.02.23-.08.3-.18.08-.1.11-.22.09-.35zm4.46.38-.57-.03-.25-.12c-.06.1-.12.17-.18.22-.11.09-.24.14-.4.16a.953.953 0 0 1-.7-.19c-.26-.18-.41-.45-.46-.81s.03-.66.24-.91a.9.9 0 0 1 .61-.34c.14-.02.28 0 .41.04a.79.79 0 0 1 .24.15l-.03-.21.71-.09.38 2.13zm-.9-.98a.494.494 0 0 0-.18-.32.46.46 0 0 0-.34-.1c-.14.02-.25.09-.32.21a.52.52 0 0 0-.07.32c.01.12.06.21.15.3.1.1.22.14.37.12a.47.47 0 0 0 .31-.18c.07-.09.1-.21.08-.35zm-1.74 1.43-.72.01-.43-3.17.7-.04.45 3.2zm4.98-.84-.67-.02-.12-1.07c-.02-.19-.05-.31-.1-.36a.286.286 0 0 0-.28-.1c-.11.01-.19.06-.26.15-.06.08-.08.19-.06.34l.14 1.3h-.79l-.24-2.04.5-.08.24.16c.07-.11.14-.19.2-.24a.8.8 0 0 1 .41-.15c.21-.02.4.02.55.13.17.12.33.32.39.69l.09 1.29zm2.63-.51-.6-.04-.14-.08c-.05.1-.11.18-.17.23-.11.09-.24.15-.39.17a.93.93 0 0 1-.7-.16c-.27-.17-.43-.44-.48-.79-.06-.36.01-.66.21-.92.16-.2.36-.32.6-.36a.94.94 0 0 1 .41.03.91.91 0 0 1 .25.14l-.23-1.41.73.08.51 3.11zm-.85-.94c-.02-.13-.09-.24-.19-.32s-.22-.11-.34-.09c-.14.02-.24.1-.31.23-.06.1-.08.21-.06.33a.47.47 0 0 0 .16.29c.11.1.23.14.37.11a.41.41 0 0 0 .3-.19c.06-.1.09-.22.07-.36z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m63.43 38.69-1.29-3.44 3.57.68z",
    fill: "#221e6e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzlLotto6From40);
export default __webpack_public_path__ + "static/media/nzl_lotto_6_from_40.eb3e1d632d6b412269a7530211685881.svg";
export { ForwardRef as ReactComponent };